/**
 * Inline SVG for PLP lazy-load / error placeholder (object-fit: contain in fixed box).
 */
export var productListSilhouetteSrc = 'data:image/svg+xml,' +
    encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 160" fill="none">' +
        '<rect width="120" height="160" fill="#ffffff"/>' +
        '<path fill="#ececec" d="M60 14c10 0 18 8 18 18v10h20l9 48v52H13V90l9-48h20V32c0-10 8-18 18-18zm0 8c-5.5 0-10 4.5-10 10v8h-2l-7 36v44h38V76l-7-36h-2v-8c0-5.5-4.5-10-10-10z"/>' +
        '</svg>');
//# sourceMappingURL=productSilhouette.js.map